export default {
  env: "",
  appName: ""
}
